"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPCTriggerType = void 0;
var NPCTriggerType;
(function (NPCTriggerType) {
    NPCTriggerType["Spawn"] = "spawn";
    NPCTriggerType["Leash"] = "leash";
    NPCTriggerType["Combat"] = "combat";
})(NPCTriggerType || (exports.NPCTriggerType = NPCTriggerType = {}));
